import { render, staticRenderFns } from "./termsCondition.vue?vue&type=template&id=0354a3cf&scoped=true"
import script from "./termsCondition.vue?vue&type=script&lang=js"
export * from "./termsCondition.vue?vue&type=script&lang=js"
import style1 from "./termsCondition.vue?vue&type=style&index=1&id=0354a3cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354a3cf",
  null
  
)

export default component.exports